(function ($, Drupal, once) {
  'use strict';

  const HIDE_DELAY = 5000;

  function scheduleHide($el, delay = HIDE_DELAY) {
    const id = window.setTimeout(function () { // <- global window
      $el.stop(true, true).slideUp();
    }, delay);
    $el.data('hideTimerId', id);
  }

  function clearHide($el) {
    const id = $el.data('hideTimerId');
    if (id) {
      window.clearTimeout(id);
      $el.removeData('hideTimerId');
    }
  }

  Drupal.behaviors.statusMessages = {
    attach: function (context) {
      once('status-message-processed', '.message-container .messages', context).forEach(function (element) {
        const $el = $(element);

        scheduleHide($el);
        $el.on('mouseenter focusin', function () { clearHide($el); });
        $el.on('mouseleave focusout', function () { if ($el.is(':visible')) scheduleHide($el); });
        $el.on('click', function () { clearHide($el); $el.stop(true, true).slideUp(); });
      });
    }
  };

})(jQuery, Drupal, once);
